"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.error.fetch': '加载数据库日志失败。',
};
